<div class="chat-message-confirm">
    <div class="chat-message-confirm-title">{{ content?.text }}</div>
    <div *ngFor="let button of content?.buttons; let i = index" 
         class="step-button"
         [ngClass]="{
             'step-button--primary': content?.buttons.length === 1 || (content?.buttons.length > 0 && i % 2 !== 0),
             'step-button--secondary': !(content?.buttons.length === 1 || (content?.buttons.length > 0 && i % 2 !== 0)),
             'step-button--disable': isInteractionDisabled
         }" 
         (click)="onButtonClick(i)">
        {{ button.label }}
    </div>    

    <div *ngIf="message.translations && translationData?.userPreferredLanguage && !translationData?.dontNeedTranslate"
        (click)="onClickTranslation()" class="btn-toggle-translation" [ngClass]="{
                'show-translation': isShowingTranslation,
                'show-original': !isShowingTranslation
              }">
        <svg-icon key="translation" size="lg" class="icon-translation"></svg-icon>
        <span>{{ isTranslating ? 'Translating' : 'AI-Powered Translation'}}</span>
    </div>
</div>